<template>
  <div class="intelligentControl-page">
    <div class="all-content-container">
      <div v-loading="isLoading" :element-loading-text="'当前控制模式切换中，时间较长，请勿点击其它操作，耐心等待'" class="intelligentControl-container" style="padding-bottom: 60px; padding-right: 20px">
        <div class="intelligentControl-top">
          <div class="title-xz-container">
            分组选择：
            <el-cascader v-model="id" :options="options" @change="change_id" :props="optionProps" placeholder="" collapse-tags></el-cascader>
            <span style="margin-left: 15px"> 设备选择： </span>
            <el-select @change="getLinkageControlListId" v-model="Switchvalue" placeholder="请选择设备">
              <el-option v-for="item in SwitchList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
            <span style="margin-left: 15px"> 控制模式： </span>
            <el-select @change="handleStatus_($event)" v-model="devicId_" placeholder="请选择">
              <el-option label="远程控制模式" :value="0"> </el-option>
              <el-option label="定时控制模式" :value="1"> </el-option>
              <el-option label="AI自动模式" :value="2"> </el-option>
            </el-select>
            <!-- <el-button style="margin-left:20px" @click="_openVideo" class="top-btn" type="primary">视频监控</el-button> -->
          </div>
          <!-- <div v-if="Sstatus==1" class="status_">
            当前生长模型启用中，请先在决策模型中禁用生长模型控制后再进行操作。
          </div> -->
          <div>
            <!-- <el-button @click="_toListPage" class="top-btn" type="primary">控制列表</el-button> -->
            <el-button @click="_open_video" class="top-btn" type="primary">视频监控管理</el-button>
          </div>
        </div>
        <div class="page_">
          <div>
            <el-row class="switch-row" style="width: 33% !important" v-for="(item, index) in list" :key="index">
              <el-col :xl="24">
                <div v-loading="item.timeshow" :element-loading-text="'当前命令下发中。。。'" class="grid-content bg-purple">
                  <div class="nav_title">
                    <div>
                      <img class="icon_png" :src="item.icon" alt="" />
                    </div>
                    <div class="nav_title_">
                      <div class="title_">
                        {{ item.cname }}
                      </div>

                      <div class="status_title a667">
                        <div class="a89896">
                          <img v-if="item.realDataConvert.includes('关')" src="../../assets/cile0.png" alt="" />
                          <img v-if="item.realDataConvert.includes('开')" src="../../assets/cile1.png" alt="" />
                        </div>
                        <span :style="item.realDataConvert.includes('关') || item.realDataConvert.includes('停') ? 'color:#666666' : ''"> 开关状态： </span>
                        <span class="a6598" style="color: #666666" v-if="item.realDataConvert.includes('关')">关闭</span>
                        <span class="a6598" v-if="item.realDataConvert.includes('开')">开启</span>
                        <span class="a6598" style="color: #666666" v-if="item.realDataConvert.includes('停')">停</span>
                        <span class="a6598" v-if="item.realDataConvert.includes('正')">正转</span>
                        <span class="a6598" v-if="item.realDataConvert.includes('反')">反转</span>
                      </div>
                      <div class="status_title">
                        {{ item.updateTime }}
                      </div>
                    </div>

                    <div v-if="item.deviceStats == 1" class="status">
                      <img src="@/assets/status0.png" alt="" />
                      在线
                    </div>
                    <div v-if="item.deviceStats == 0" class="status">
                      <img src="@/assets/status1.png" alt="" />
                      离线
                    </div>
                    <div v-if="item.videoId" @click="_openVideo(item.videoId)" class="status a6"><img class="viedeo_img" src="../../assets/images/video.png" alt="" />视频监控</div>
                    <div v-if="!item.videoId" class="status a6" style="margin-top: 5px"><img class="viedeo_img_" src="../../assets/images/video0.png" alt="" />视频监控</div>
                  </div>
                  <div class="kg_title">
                    <div>开关操作</div>
                    <div @click="_openRecord(item.id, item.cname, item.deviceName)" class="kg_jl">
                      <img src="@/assets/jl.png" alt="" />
                      <span style="margin-left: 5px"> 开关记录 </span>
                    </div>
                  </div>
                  <div v-if="item.switchType == 8" class="cz_nav">
                    <div @click="openOrCloseSwitch_(item.id, itemc.id, index)" :class="itemc.value != item.realData ? 'cz_box' : 'cz_box1'" v-for="itemc in item.customSwitchCmds" :key="itemc.id">
                      <span style="white-space: nowrap">
                        {{ itemc.name }}
                      </span>
                      <img v-if="itemc.value != item.realData" src="@/assets/status_open.png" alt="" />
                      <img v-else src="@/assets/status_open1.png" alt="" />
                      <!-- <el-switch style="margin-right:10px" v-model="value" active-color="#13ce66" inactive-color="#ff4949">
                      </el-switch> -->
                    </div>
                  </div>
                  <div v-if="item.switchType == 3 || item.switchType == 0" class="cz_nav">
                    <div @click="openOrCloseSwitch_(item.id, 1, index)" class="cz_box">
                      <span style="white-space: nowrap"> 开启 </span>
                      <img src="@/assets/status_open.png" alt="" />
                      <!-- <el-switch style="margin-right:10px" v-model="value" active-color="#13ce66" inactive-color="#ff4949">
                      </el-switch> -->
                    </div>
                    <div @click="openOrCloseSwitch_(item.id, 0, index)" class="cz_box1">
                      <span style="white-space: nowrap"> 关闭 </span>
                      <img src="@/assets/status_open1.png" alt="" />
                      <!-- <el-switch style="margin-right:10px" v-model="value" active-color="#13ce66" inactive-color="#ff4949">
                      </el-switch> -->
                    </div>
                  </div>
                  <div v-if="item.switchType == 1 || item.switchType == 4" class="cz_nav">
                    <div @click="openAdd_(item.id, item.realData)" class="cz_box center">
                      <span style="white-space: nowrap">
                        {{ item.realDataConvert }}
                      </span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <!-- <div class="empty-box" v-if="list.length == 0">
            <img :src="empty_img" />
          </div> -->
          </div>
        </div>
        <!-- <div class="pagination-content-container" style="float: right; margin-top: 10px">
          <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" :total="total"></el-pagination>
        </div> -->
        <el-dialog title="开关开度" :visible.sync="isStatus" width="30%">
          <el-form ref="dialogformInlineadd" :model="dialogformInlineadd" :rules="dialogRules" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="开关开度：" prop="openValue">
                  <el-input v-model="dialogformInlineadd.openValue" clearable placeholder="请输入开关开度" maxlength="20"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isStatus = false">取 消</el-button>
            <el-button type="primary" @click="openValue_">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="更多信息" :visible.sync="isMore" width="50%">
          <ul class="dialog-list">
            <li v-for="item in lItem" :key="item.id">
              <p>执行动作：{{ item.switchTypeText }}</p>
              <p>触发条件：{{ item.triggerCondition }}</p>
            </li>
          </ul>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isMore = false">取 消</el-button>
            <!-- <el-button type="primary" @click="isMore = false">确 定</el-button> -->
          </span>
        </el-dialog>
        <el-dialog title="视频监控" :visible.sync="videoEdit" width="30%">
          <el-form ref="dialogformInlineadd" :model="dialogformInlineadd" :rules="dialogRules" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="操作名称：" prop="attributeId">
                  <el-select v-model="videoForm.attributeId" placeholder="请选择">
                    <el-option v-for="item in list" :key="item.id" :label="item.cname" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="摄像头名称：" prop="videoId">
                  <el-select v-model="videoForm.videoId" placeholder="请选择">
                    <el-option v-for="item in attachmentLink" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="videoEdit = false">取 消</el-button>
            <el-button type="primary" @click="submitVideo">确 定</el-button>
          </span>
        </el-dialog>
        <div v-drag class="draggable" v-if="isVideo" width="70%">
          <img v-if="isVideo_" @click="dbclose" class="img_del" src="@/assets/img/del.png" alt="" />
          <div class="box_">
            <div class="center">
              <video style="margin-bottom: 20px" id="videoPlayer" class="video-js vjs-default-skin" controls playsinline autoplay="autoplay" width="700px">
                <source :src="video_0.playM3u8" type="application/x-mpegURL" />
              </video>
            </div>
          </div>

          <span slot="footer" class="dialog-footer a12">
            <div></div>
            <div>
              <!-- <el-button style="margin:20px" @click="isVideo = false">确定</el-button> -->
            </div>

            <!-- <el-button type="primary" @click="isMore = false">确 定</el-button> -->
          </span>
        </div>
        <el-dialog :title="title_open" :before-close="handleClose_123" :visible.sync="isrecord" width="45%">
          <el-col :span="12">
            <div class="flex" style="margin: 10px">
              <div class="titii">操作时间：</div>
              <el-date-picker v-model="searchFormControlRecord.time" type="datetimerange" :picker-options="pickerOptions" @change="getTime" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"> </el-date-picker>
            </div>
          </el-col>
          <!-- <el-col :span="9">
            <div class="flex" style="margin:10px">
              <div class="titii">
                操作内容：
              </div>
              <el-input v-model="searchFormControlRecord.content" placeholder="请输入内容"></el-input>
            </div>
          </el-col> -->
          <el-col :span="7" style="margin: 7px">
            <el-button type="primary" class="status_open a33" @click="_getWaterPipeList"> 查询 </el-button>
            <el-button type="primary" class="status_open a33" @click="reasta13"> 重置 </el-button>
          </el-col>
          <div class="table_content1" style="margin-top: 10px">
            <el-table :data="tableData_" align="center" class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
              <el-table-column prop="operation" align="center" label="开关操作" width> </el-table-column>
              <el-table-column prop="operator" align="center" label="操作人" width> </el-table-column>
              <el-table-column prop="updateTime" align="center" label="时间" width></el-table-column>
            </el-table>
          </div>

          <div class="pagination-content-container" style="float: left; margin-top: 10px">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange_" :current-page="searchFormControlRecord.pageNum" :page-size="searchFormControlRecord.pageSize" :total="searchFormControlRecord.total"></el-pagination>
          </div>
          <div class="dialog-footer_1" style="float: right; margin-top: 10px">
            <!-- <el-button @click="isrecord = false">取 消</el-button> -->
            <!-- <el-button type="primary" @click="handleClose_123">确 定</el-button> -->
          </div>
        </el-dialog>

        <!-- 视频监控  -->
        <el-dialog :title="title_open" :before-close="handleClose_video" :visible.sync="isVdeio_1" width="45%">
          <el-col :span="12" style="margin: 7px">
            <el-button type="primary" class="status_open a33" @click="openVideoEdit(-1)"> 添加 </el-button>
          </el-col>
          <div class="table_content1" style="margin-top: 10px">
            <el-table :data="SwtichAttrVideoList" align="center" class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
              <el-table-column prop="ename" align="center" label="分组名称" width> </el-table-column>
              <el-table-column prop="attributeName" align="center" label="操作名称" width> </el-table-column>
              <el-table-column prop="ename" align="center" label="摄像头名称" width> </el-table-column>
              <el-table-column align="center" label="操作" width="260">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="openVideoEdit(scope.row.id)">编辑</el-button>
                  <el-button style="color: red" type="text" size="small" @click="delObjDeviceSwtichAttrVideo(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="pagination-content-container" style="float: left; margin-top: 10px">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange_Video" :current-page="searchFormVideo.pageNum" :page-size="searchFormVideo.pageSize" :total="searchFormVideo.total"></el-pagination>
          </div>
          <div class="dialog-footer_1" style="float: right; margin-top: 10px">
            <!-- <el-button @click="isrecord = false">取 消</el-button> -->
            <!-- <el-button type="primary" @click="handleClose_123">确 定</el-button> -->
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
export default {
  name: 'intelligentControl',
  data() {
    return {
      timeshow: true,
      devicId_: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近6小时',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 6)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近12小时',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 12)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      searchFormControlRecord: {
        id: '',
        pageNum: 1,
        pageSize: 10,
        total: 1,
        startDate: '',
        endDate: '',
        time: '',
        content: ''
      },
      searchFormVideo: {
        id: '',
        pageNum: 1,
        pageSize: 10,
        total: 1
      },
      dp: null,
      options_: {
        autoplay: false, // 设置自动播放
        muted: true, // 设置了它为true，才可实现自动播放,同时视频也被静音（Chrome66及以上版本，禁止音视频的自动播放）
        preload: 'auto', // 预加载
        controls: true // 显示播放的控件
      },
      attachmentLink: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      tableData_: [],
      attributeId: '',
      empty_img: require('../../assets/img/timg.jpg'),
      total: 0,
      id: '0',
      noData: '',
      list: [],
      options: [],
      id: '', //主键id ，根据具体业务进行判定
      currentPage: 1, //第几页，默认1
      pageSize: 6, //默认展示多少条，默认10
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true
      },
      videoForm: {
        attributeId: '',
        eid: '',
        groupId: '',
        videoId: '',
        id: ''
      },
      videoEdit: false,
      value: '',
      lItem: [],
      isMore: false,
      isVideo: false,
      isVideo_: false,
      isrecord: false,
      isLoading: false,
      isStatus: false,
      isVdeio_1: false,
      code: '',
      SwtichAttrVideoList: [],
      SwitchList: [],
      Switchvalue: '',
      Sstatus: '',
      video_0: {},
      dialogformInlineadd: {
        id: '',
        //添加参数或者编辑参数
        openValue: ''
      },
      dialogRules: {
        // 弹框表单验证

        openValue: [{ required: true, message: '请输入模拟开关开度', trigger: 'change' }]
      },
      dragging: false,
      x: 0,
      y: 0,
      startX: 0,
      startY: 0
    }
  },

  timer: '',
  title_open: '',
  directives: {
    drag: {
      // 指令的定义
      bind: function (el) {
        console.log(el)
        let oDiv = el // 获取当前元素
        oDiv.onmousedown = e => {
          // 算出鼠标相对元素的位置
          let disX = e.clientX - oDiv.offsetLeft
          let disY = e.clientY - oDiv.offsetTop
          document.onmousemove = e => {
            // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            let left = e.clientX - disX
            let top = e.clientY - disY
            oDiv.style.left = left + 'px'
            oDiv.style.top = top + 'px'
          }
          document.onmouseup = e => {
            document.onmousemove = null
            document.onmouseup = null
          }
        }
      }
    }
  },

  created() {
    this.getGroupList()
    console.log(this.searchFormControlRecord)
  },
  mounted() {
    // this.timer = setInterval(() => {
    //   this.getSwitchList()
    //   this.getBoxStatus()
    // }, 10000)

    setTimeout(() => {}, 1000)
    this.getUserDetails()
  },
  // 销毁
  beforeDestroy() {
    if (this.dp) {
      this.dp.dispose() // dispose()会直接删除Dom元素
    }
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    getBoxStatus() {
      this.$api.growthModel.getBoxStatus({ id: this.id }).then(res => {
        if (res.code == 200) {
          this.devicId_ = Math.round(res.data.value)
        }
      })
    },
    handleStatus_(val, id) {
      let data = {
        groupId: this.id,
        status: val
      }
      if (val != 2) {
        this.$api.growthModel.openOrCloseGrowthModelDecision({ groupId: this.id, status: 0, day: 0 })
      }
      this.$api.growthModel.changeBox(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.isLoading = true
          setTimeout(() => {
            this.getBoxStatus()
            this.$forceUpdate()
            this.isLoading = false
          }, 30000)
          // this.handleSearch()
        }
      })
    },
    submitVideo() {
      this.videoForm.groupId = this.id
      this.videoForm.eid = this.Switchvalue
      this.$api.system.saveObjDeviceSwtichAttrVideo(this.videoForm).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.videoEdit = false
          this._getObjDeviceSwtichAttrVideoList()
        }
      })
    },
    openVideoEdit(row) {
      this.videoEdit = true
      this.videoForm = {
        attributeId: '',
        videoId: ''
      }
      this.getVideosByGroupId()

      if (row != -1) {
        this.getObjDeviceSwtichAttrVideo(row)
      }
    },
    getObjDeviceSwtichAttrVideo(row) {
      this.$api.system.getObjDeviceSwtichAttrVideo({ id: row }).then(res => {
        if (res.code == 200) {
          this.videoForm = res.data
        }
      })
    },
    delObjDeviceSwtichAttrVideo(row) {
      this.$api.system.delfun(`/pc/objDeviceSwtichAttrVideo/delObjDeviceSwtichAttrVideo`, row).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this._getObjDeviceSwtichAttrVideoList()
        }
      })
    },
    _open_video() {
      this.isVdeio_1 = true
      this._getObjDeviceSwtichAttrVideoList()
    },
    _getObjDeviceSwtichAttrVideoList() {
      this.searchFormVideo.id = this.id
      this.$api.system.getObjDeviceSwtichAttrVideoList(this.searchFormVideo).then(res => {
        if (res.code == 200) {
          this.SwtichAttrVideoList = res.data
        }
      })
    },
    getUserDetails() {
      this.$api.system.getUserDetails(sessionStorage.getItem('USER_ID')).then(res => {
        if (res.code == 200) {
          sessionStorage.setItem('USER_groupID', res.data.groupId)
        }
      })
    },
    getTime(val) {
      this.searchFormControlRecord.startDate = val[0]
      this.searchFormControlRecord.endDate = val[1]
      this._getWaterPipeList()
      console.log(223)
    },
    handleClose_123() {
      this.isrecord = false
      this.searchFormControlRecord = {
        pageNum: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        time: '',
        content: ''
      }
    },
    handleClose_video() {
      this.isVdeio_1 = false
      this.searchFormVideo = {
        pageNum: 1,
        pageSize: 10,
        total: 1
      }
      this.getLinkageControlList()
    },
    _getWaterPipeList() {
      this.searchFormControlRecord.eid = this.Switchvalue
      this.searchFormControlRecord.attributeId = this.attributeId
      this.$api.device.getDataHisSwitchList(this.searchFormControlRecord).then(res => {
        if (res.code == 200) {
          this.tableData_ = res.data
          this.searchFormControlRecord.total = res.count
        }
      })
    },
    // 分页
    handleCurrentChange(currentPage) {
      this.pageNum = currentPage
      this._getWaterPipeList()
    },
    getVideosByGroupId() {
      this.$api.device.getVideosByGroupId({ id: this.id }).then(res => {
        if (res.code == 200) {
          this.attachmentLink = res.data
          setTimeout(() => {
            this.loadVideo()
          }, 1000)
        }
      })
    },
    dbclose() {
      var video = videojs('videoPlayer')
      console.log(video)
      video.dispose()
      this.isVideo = false
      this.isVideo_ = false
    },
    loadVideo() {
      this.db = videojs(`videoPlayer`, this.options_)
      // this.attachmentLink.map((item, index) => {
      // })
      // 也可以使用以下方式给vedio设置 src
      // this.db.src([
      //   {
      //     src: "https://e-sign.dms.t.cn-np.com/files/m3u8_file/c4b94118-3c8d-4410-9987-985c2b44c278/c4b94118-3c8d-4410-9987-985c2b44c278.m3u8", // 地址
      //     type: "application/x-mpegURL", // 告诉videojs,这是一个hls流
      //   },
      // ]);
    },
    getLinkageControlListId(val, name) {
      var name = ''
      this.SwitchList.map(item => {
        if (item.id == val) {
          name = item.name
        }
      })
      this.Switchvalue = val
      this.getLinkageControlList()
      this.getGrowthModelDecisionByDeviceName(name)
    },
    getGrowthModelDecisionByDeviceName(val) {
      this.$api.device.getGrowthModelDecisionByDeviceName({ str: val }).then(res => {
        if (res.code == 200) {
          console.log(res)
          this.Sstatus = res.data.status
        }
      })
    },
    _openMore(items) {
      this.lItem = items
      this.isMore = true
    },
    _openVideo(id) {
      this.getVideo(id)
      this.isVideo = true
      setTimeout(() => {
        this.isVideo_ = true
      }, 1800)
    },
    getVideo(id) {
      this.$api.system.getVideo(id).then(res => {
        if (res.code == 200) {
          this.video_0 = res.data
          setTimeout(() => {
            this.loadVideo()
          }, 1000)
        }
      })
    },
    _openRecord(id, name, deviceName) {
      this.attributeId = id
      this.title_open = `${deviceName}_${name}_开关记录`
      this.isrecord = true
      this._getWaterPipeList()
    },
    reasta13() {
      this.searchFormControlRecord.startDate = ''
      this.searchFormControlRecord.endDate = ''
      this.searchFormControlRecord.time = ''
      this.searchFormControlRecord.content = ''
      this.searchFormControlRecord.pageNum = 1
      this._getWaterPipeList()
    },
    // 查询智能控制属性列表`
    getLinkageControlList() {
      this.$api.device
        .getAttributesBySwtichId({ id: this.Switchvalue })
        .then(res => {
          if (res.code == 200) {
            res.data.map(item => {
              if (item.cname !== null && item.cname.includes('温控')) {
                item.icon = require('@/assets/wk.png')
              } else if (item.cname !== null && item.cname.includes('内风机')) {
                item.icon = require('@/assets/nfj.png')
              } else if (item.cname !== null && item.cname.includes('外风机')) {
                item.icon = require('@/assets/wfj.png')
              } else if (item.cname !== null && item.cname.includes('湿控')) {
                item.icon = require('@/assets/sk.png')
              } else if (item.cname !== null && item.cname.includes('C02')) {
                item.icon = require('@/assets/Co.png')
              } else if (item.cname !== null && item.cname.includes('滴灌')) {
                item.icon = require('@/assets/dg.png')
              } else if (item.cname !== null && item.cname.includes('补光')) {
                item.icon = require('@/assets/bg.png')
              } else if (item.cname !== null && item.cname.includes('灯光')) {
                item.icon = require('@/assets/dzkg.png')
              } else if (item.cname !== null && item.cname.includes('蒸发')) {
                item.icon = require('@/assets/zf.png')
              } else if (item.cname !== null && item.cname.includes('升降')) {
                item.icon = require('@/assets/sj.png')
              } else if (item.cname !== null && item.cname.includes('加湿')) {
                item.icon = require('@/assets/jsfg.png')
              } else if (item.cname !== null && item.cname.includes('制冷制热')) {
                item.icon = require('@/assets/zl.png')
              } else if (item.cname !== null && item.cname.includes('上层电机')) {
                item.icon = require('@/assets/sc.png')
              } else if (item.cname !== null && item.cname.includes('下层电机')) {
                item.icon = require('@/assets/xc.png')
              } else if (item.cname !== null && item.cname.includes('加热制冷')) {
                item.icon = require('@/assets/jr.png')
              } else if (item.cname !== null && item.cname.includes('加湿自动')) {
                item.icon = require('@/assets/js.png')
              } else if (item.cname !== null && item.cname.includes('加热')) {
                item.icon = require('@/assets/jr1.png')
              } else if (item.cname !== null && item.cname.includes('制冷')) {
                item.icon = require('@/assets/zl1.png')
              } else if (item.cname !== null && item.cname.includes('控制模式')) {
                item.icon = require('@/assets/kzms.png')
              } else if (item.cname !== null && item.cname.includes('锅炉')) {
                item.icon = require('@/assets/gl.png')
              } else if (item.cname !== null && item.cname.includes('风机')) {
                item.icon = require('@/assets/fj.png')
              } else if (item.cname !== null && item.cname.includes('内遮阳')) {
                item.icon = require('@/assets/nzy.png')
              } else if (item.cname !== null && item.cname.includes('天窗')) {
                item.icon = require('@/assets/tc.png')
              } else if (item.cname !== null && item.cname.includes('灌溉')) {
                item.icon = require('@/assets/gg.png')
              } else if (item.cname !== null && item.cname.includes('侧保温')) {
                item.icon = require('@/assets/cbw.png')
              } else if (item.cname !== null && item.cname.includes('内保温')) {
                item.icon = require('@/assets/nbw.png')
              } else if (item.cname !== null && item.cname.includes('二氧化碳')) {
                item.icon = require('@/assets/c2.png')
              } else if (item.cname !== null && item.cname.includes('遮阳')) {
                item.icon = require('@/assets/zy.png')
              } else if (item.cname !== null && item.cname.includes('湿帘')) {
                item.icon = require('@/assets/sl.png')
              }
            })
            this.list = res.data
            this.total = res.count
          }
        })
        .catch(err => {})
    },
    openValue_() {
      let data = {
        id: this.Switchvalue,
        attributeId: this.dialogformInlineadd.id,
        openValue: this.dialogformInlineadd.openValue
      }
      this.$api.system.openOrCloseSwitch_(data).then(res => {
        if (res.code == 200) {
          this.$message({ type: 'success', message: res.msg })
          this.getLinkageControlList()
          this.isStatus = false
        }
      })
    },
    openAdd_(id, value) {
      this.dialogformInlineadd.id = id
      this.dialogformInlineadd.openValue = Math.trunc(value)
      this.isStatus = true
    },
    openOrCloseSwitch_(attributeId, modelRuleSwitchCmdId, index) {
      if (this.devicId_ != 0) {
        const h = this.$createElement
        this.$msgbox({
          title: '注意:',
          message: h('p', null, [h('i', { style: 'color: teal' }, '当前运行模式非远程控制模式，请切换模式后再进行操作。')]),
          confirmButtonText: '确定',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {})
        // this.$msgbox({
        //   message: h('p', null, [h('span', null, '内容可以是 '), h('i', { style: 'color: teal' }, '当前生长模型控制已启用，请先在决策模型中禁用生长模型控制后再进行操作')]),
        //   confirmButtonText: '确定',
        //   callback: (action) => {}
        // })
      } else {
        let data = {
          id: this.Switchvalue,
          attributeId: attributeId
        }
        if (modelRuleSwitchCmdId == 0 || modelRuleSwitchCmdId == 1) {
          data.swtichStatus = modelRuleSwitchCmdId
        } else {
          data.modelRuleSwitchCmdId = modelRuleSwitchCmdId
        }
        this.timeer(index)
        this.$api.system.openOrCloseSwitch_(data).then(res => {
          if (res.code == 200) {
            this.$message({ type: 'success', message: res.msg })
          } else {
          }
        })
      }
    },
    timeer(index) {
      this.list[index].timeshow = true
      console.log(this.list[index].timeshow)
      this.$forceUpdate()
      var that = this
      var time = 1
      let time1 = setInterval(() => {
        if (time == 0) {
          time = 1
          this.list[index].timeshow = false
          clearInterval(time1)
          this.getLinkageControlList()
        } else {
          time = time - 1
        }
        console.log(time)
      }, 1000)
    },
    //大棚
    getGroupList() {
      this.$api.system.getConfigGroupTree(0).then(res => {
        if (res.code == 200) {
          // this.id = res.data[0].id //默认id
          if (Number(sessionStorage.getItem('USER_groupID'))) {
            this.id = Number(sessionStorage.getItem('USER_groupID')) //默认id
          } else {
            this.id = res.data[0].id
          }
          this.getSwitchList()
          this.options = res.data
          this.getBoxStatus()
        }
      })
    },
    saveUserGroup(val) {
      this.$api.system.saveUserGroup({ id: val }).then(res => {
        if (res.code == 200) {
        }
      })
    },

    getSwitchList() {
      this.$api.system
        .getSwitchList(
          this.currentPage, //第几页，默认1
          6, //默认展示多少条，默认10
          this.code, //设备编码
          this.id // 分组id
        )
        .then(res => {
          if (res.code == 200) {
            if (res.data.length > 0) {
              this.Switchvalue = res.data[0].id
              this.getGrowthModelDecisionByDeviceName(res.data[0].name)
              this.getLinkageControlList()
            }
            this.SwitchList = res.data
          }
        })
    },
    //大棚处理
    change_id(val) {
      this.id = val[val.length - 1]
      // this.getLinkageControlList()
      this.saveUserGroup(this.id)
      this.getSwitchList()
    },

    operationType(item, type, text) {
      this.$confirm(`是否切换到${text}？`, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this._updateLinkageControlType(item, type)
        })
        .catch(() => {
          this.$message.info(`已取消切换到${text}`)
        })
      this.getLinkageControlList()
    },
    _updateLinkageControlType(item, type) {
      this.$api.device.updateLinkageControlType(item.controlId, type).then(res => {
        if (res.code == 200) {
          this.getLinkageControlList()
        }
      })
    },
    // 判断开关是否存在正在运行的生长模型，有的话需要确认弹窗提示是否继续
    _openOrCloseDeviceSwtich(item, type) {
      if (!item.eid || !item.attributeId) {
        this.$toaster.error('该开关存在问题')
        return
      }
      this.$api.growthModel
        .getModelStatus({
          switchId: item.eid,
          attributeId: item.attributeId
        })
        .then(res => {
          if (res.code == 200) {
            if (res.data == 1) {
              this.$confirm('有生长模型正在使用该设备，是否继续操作？', '操作', {
                distinguishCancelAndClose: true,
                confirmButtonText: '继续',
                cancelButtonText: '取消'
              }).then(() => {
                // 开关关闭
                this.openOrCloseDeviceSwtich(item, type)
              })
            } else {
              // 开关关闭
              this.openOrCloseDeviceSwtich(item, type)
            }
          }
        })
    },
    // 开启或关闭
    openOrCloseDeviceSwtich(item, type) {
      let obj = {
        id: item.eid,
        attributeId: item.attributeId
      }
      if (item.switchType == 1 || item.switchType == 4) {
        if (item.realVal == null) {
          this.$toaster.error('请输入开度')
          return false
        }
        obj.openValue = item.realVal
      } else if (item.switchType == 8) {
        obj.modelRuleSwitchCmdId = type
      } else {
        obj.swtichStatus = type
      }
      this.$api.device.openOrCloseDeviceSwtich(obj).then(res => {
        if (res.code == 200) {
          this.$toaster.ok(res.msg)
          this.getLinkageControlList()
        }
      })
    },
    //分页
    handleCurrentChange_(currentPage) {
      this.searchFormControlRecord.pageNum = currentPage
      // this.id = "";
      this._getWaterPipeList()
    },
    handleCurrentChange_Video(currentPage) {
      this.searchFormControlRecord.pageNum = currentPage
      this._getObjDeviceSwtichAttrVideoList()
    },
    _toListPage() {
      this.$router.push({
        name: `intelligentControl0`
      })
    },
    _toListPage3(id, kztype) {
      sessionStorage.setItem('projectEditId', id)
      sessionStorage.setItem('kztype', kztype)
      this.$router.push({
        path: `layout/linkagecenter3`
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/style/intelligentControl.scss';
.status_ {
  margin-bottom: 20px;
  color: red;
  font-size: 20px;
  font-weight: bold;
}

.center {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
.box_ {
  width: 750px;
  height: 450px;
  overflow-y: auto;
}
.intelligentControl-page {
  overflow: hidden;
}

li {
  padding-left: 15px;
}

.icom_dailog3 {
  position: absolute;
  top: 0px;
  left: -10px;
  color: #ff7574;
}

.icom_dailog {
  transform: translate(-10px, 5px);
  position: absolute;
  top: -5px;
}

.intelligentControl-top {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top-btn {
  margin-bottom: 20px;
}

.middle-left-container {
  //background: #256bff52;
}

.middle-left-container img {
  width: 100% !important;
  height: 100% !important;
}

.action-list {
  color: #999;
  font-size: 14px;
  line-height: 23px;
  margin-bottom: 10px;
  width: 50%;
  float: left;
  padding-top: 20px;
}

.action-list .action-lable {
  width: 80px;
  color: #666;
}

.action-list .action-val {
  width: 230px;
  color: #226cff;
}

.colorStatus1 {
  color: #333;
}

.span-class {
  width: 66px !important;
  display: inline-block !important;
  margin-top: 5px;
  margin-left: 5px;
  margin-right: 5px;
}

.line {
  width: 4px;
  height: 15px;
  background: #326ff6;
  float: left;
  margin-top: 3px;
  margin-right: 8px;
}

.time-bg {
  background: url('../../assets/sjbg.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 36px;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  color: #fff;
  font-style: italic;
}

.time-bg2 {
  background: url('../../assets/sjbg.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 36px;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  line-height: 36px;
  color: #fff;
}

.week-box {
  height: 32px;

  .img_1 {
    width: 13%;
    float: right;
  }

  .img_all {
    width: 13%;
    margin-right: 1.5%;
    float: right;
  }
}
.draggable {
  position: absolute;
  width: 690px;
  min-height: 50%;
  background-color: transparent;
  top: 10%;
  left: 35%;
  cursor: move;
}
.a12 {
  display: flex;
  justify-content: space-between;
}
.img_del {
  position: relative;
  float: right;
  // right: 3rem;
  top: 50px;
  z-index: 9999999999999 !important;
  cursor: pointer;
}
.flex {
  display: flex;
  align-items: center;
}
.titii {
  white-space: nowrap;
}

::deep .el-date-editor {
  .el-range-separator {
    width: 12% !important;
  }
}
.a6598 {
  font-size: 22px;
  margin-bottom: 10px;
}
.icon_png {
  margin-top: 5px;
  width: 70px;
}
.a89896 {
  margin-right: 5px;
}
</style>
